import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/*import {NoopAnimationsModule} from '@angular/platform-browser/animations'; //disable animations*/
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { OverlayModule } from '@angular/cdk/overlay';
import { FlexLayoutModule } from '@angular/flex-layout';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { CustomMaterialModule } from './custom-material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { DatePipe } from '@angular/common';
import { MatSpinner } from '@angular/material';

import { NavService } from './_services/nav.service';
import { AuthService } from './_services/auth.service';
import { TokenInterceptorService } from './_services/token-interceptor.service';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MatConfirmDialogComponent } from './_share/mat-confirm-dialog/mat-confirm-dialog.component';

/* Feature Module */
import { ShareModule } from './_share/share.module';
import { AdministratorModule } from './Administrator/administrator.module';
import { CompanyModule } from './Company/company.module';
import { EcommerceModule } from './Ecommerce/ecommerce.module';
import { ChemistshopModule } from './Chemistshop/chemistshop.module';
import { LeadCrmModule } from './LeadCRM/leadcrm.module';

import { LoginComponent } from './login/login.component';
import { PageNotFoundComponent } from './_share/page-not-found/page-not-found.component';
import { ErrorInterceptorService } from './_services/error-interceptor.service';
import { MyAccountComponent } from './my-account/my-account.component';


@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    MatConfirmDialogComponent,
    LoginComponent,
    PageNotFoundComponent,
    MyAccountComponent,    
  ],
  imports: [
    BrowserModule,
    LoadingBarRouterModule,
    LoadingBarHttpClientModule,
    BrowserAnimationsModule,
    OverlayModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    FormsModule,
    HttpClientModule,
    CustomMaterialModule,
    ShareModule,
    AdministratorModule,
    CompanyModule,
    EcommerceModule,
    LeadCrmModule,
    ChemistshopModule,
    AppRoutingModule,
  ],
  providers: [ NavService, AuthService,
    { 
      provide : HTTP_INTERCEPTORS, 
      useClass : TokenInterceptorService, 
      multi: true 
    },
    {
      provide : HTTP_INTERCEPTORS, 
      useClass : ErrorInterceptorService, 
      multi: true 
    },
    DatePipe    
  ],
  bootstrap: [AppComponent],
  entryComponents: [ MatSpinner, MatConfirmDialogComponent 
  ]
})
export class AppModule { }
